import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { PageTitle, usePageData } from "src/_metronic/layout/core";
import OnlineGrid from "./OnlineGrid";
import { OrderTransport } from "src/app/transports/order";
import { allValuesAsync } from "./onlineHelps";
import useOnlineGridColumns from "./useOnlineGridColumns";

const OnlineGridAll: React.FC = () => {
    const { formatMessage } = useIntl();

    const { setPageToolbarLinks } = usePageData();
    const location = useLocation();
    const gridColumns = useOnlineGridColumns(allValuesAsync);

    useEffect(() => {
        setPageToolbarLinks([]);
    }, [location]);

    return (
        <>
            <PageTitle>{formatMessage({ id: "online.title" })}</PageTitle>
            <OnlineGrid
                gridColumns={gridColumns}
                totalRowsHandle={OrderTransport.online.all.findTotal}
                listHandler={OrderTransport.online.all.list}
                totalFilteredHandle={OrderTransport.online.all.findTotalFiltered}
                exportHandler={OrderTransport.online.all.export}
            />
        </>
    );
};

export default OnlineGridAll;
